import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { auth } from "../services/firebase";
import { sendPasswordResetEmail } from "firebase/auth";

function PasswordReset() {
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: "" } });

  function onSubmit(data) {
    setErrorMessage(null);
    setLoading(true);

    sendPasswordResetEmail(auth, data.email)
      .then((e) => {
        setComplete(true);
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div className="container">
      {loading && <div className="loading-screen regular-2xl">Loading...</div>}
      {complete && (
        <div className="loading-screen regular-2xl">
          Check your email and follow the link to create a new password
        </div>
      )}

      <h2 className="mb-2 text-center">Password Reset</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="fieldgroup justify-center">
          <fieldset>
            <label>Email</label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "This field is required",
              }}
              render={({ field }) => <input type="email" {...field} />}
            />
            <span className="input-error">{errors["email"]?.message}</span>
          </fieldset>
        </div>

        {errorMessage && <div className="input-error">{errorMessage}</div>}

        <div className="mt-2 text-center">
          <button className="button" type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default PasswordReset;
